'use strict';

var _regeneratorRuntime = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode,
    DAGLink = _require.DAGLink;

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

var uint8ArrayFromString = require('uint8arrays/from-string');

module.exports = configure(function (api) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
      var options,
          res,
          data,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return api.post('object/get', {
                timeout: options.timeout,
                signal: options.signal,
                searchParams: toUrlSearchParams(_objectSpread({
                  arg: "".concat(cid instanceof Uint8Array ? new CID(cid) : cid),
                  dataEncoding: 'base64'
                }, options)),
                headers: options.headers
              });

            case 3:
              res = _context.sent;
              _context.next = 6;
              return res.json();

            case 6:
              data = _context.sent;
              return _context.abrupt("return", new DAGNode(uint8ArrayFromString(data.Data, 'base64pad'), (data.Links || []).map(function (l) {
                return new DAGLink(l.Name, l.Size, l.Hash);
              })));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
});